import ApiService from "@/services/api.service";

class SignalementError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const buildSignalementError = (error, fallbackMessage) => {
  const status = error && error.response ? error.response.status : null;
  const data = error && error.response ? error.response.data : null;
  const message =
    (data && (data.detail || data.message || data.error)) ||
    error.message ||
    fallbackMessage;
  return new SignalementError(status, message);
};

const SignalementService = {
  list: async function() {
    try {
      const response = await ApiService.get("/signalements");
      return response;
    } catch (error) {
      throw buildSignalementError(error, "Impossible de recuperer les signalements.");
    }
  },

  getById: async function(id) {
    try {
      const response = await ApiService.get(`/signalements/${id}`);
      return response;
    } catch (error) {
      throw buildSignalementError(error, "Impossible de recuperer le signalement.");
    }
  },

  create: async function(payload) {
    try {
      const response = await ApiService.post("/signalements", payload);
      return response;
    } catch (error) {
      throw buildSignalementError(error, "Impossible de creer le signalement.");
    }
  },

  update: async function(id, payload) {
    try {
      const response = await ApiService.put(`/signalements/${id}`, payload);
      return response;
    } catch (error) {
      throw buildSignalementError(error, "Impossible de mettre a jour le signalement.");
    }
  },

  remove: async function(id) {
    try {
      const response = await ApiService.delete(`/signalements/${id}`);
      return response;
    } catch (error) {
      throw buildSignalementError(error, "Impossible de supprimer le signalement.");
    }
  }
};

export default SignalementService;

export { SignalementService, SignalementError };
